import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconRowHeightSmall = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 9.75C4.25 9.33579 4.58579 9 5 9H19C19.4142 9 19.75 9.33579 19.75 9.75C19.75 10.1642 19.4142 10.5 19 10.5H5C4.58579 10.5 4.25 10.1642 4.25 9.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 18.75C4.25 18.3358 4.58579 18 5 18H19C19.4142 18 19.75 18.3358 19.75 18.75C19.75 19.1642 19.4142 19.5 19 19.5H5C4.58579 19.5 4.25 19.1642 4.25 18.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5 13.5C4.58579 13.5 4.25 13.8358 4.25 14.25C4.25 14.6642 4.58579 15 5 15H19C19.4142 15 19.75 14.6642 19.75 14.25C19.75 13.8358 19.4142 13.5 19 13.5H5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M4.25 5.25C4.25 4.83579 4.58579 4.5 5 4.5H19C19.4142 4.5 19.75 4.83579 19.75 5.25C19.75 5.66421 19.4142 6 19 6H5C4.58579 6 4.25 5.66421 4.25 5.25Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconRowHeightSmall as ReactComponent };
